export const FFOrange = "#f38b3c";
export const FFBlack = "#101020";
export const FFOffwhite = "#FFF8F3";
export const FFMidGray = "#9599A8";
export const FFDarkGray = "#4C4E56";

export const FFOrangeMid = "#F27718";
export const FFOrangeDark = "#DB470B";
